import {workflowPaths} from './services/workflow';
import TaxpayerWorkflowPage from './pages/TaxpayerWorkflowPage';
import QuickAssistantPage from './pages/QuickAssistantPage';
import NotificationsPage from './pages/NotificationsPage';
import { getAuthToken, getStoredProfile, clearAuthSession } from './services/authSession';
import { hasSessionHandoff, beginSessionHandoff } from './services/sessionHandoff';
import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Sidebar from './components/layout/Sidebar';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import DossierPage from './pages/DossierPage';
import DeclarationRegisterPage from './pages/DeclarationRegisterPage';
import EstablishmentsPage from './pages/EstablishmentsPage';
import LicensesPage from './pages/LicensesPage';
import RenewalsPage from './pages/RenewalsPage';
import ReportsPage from './pages/ReportsPage';
import SettingsPage from './pages/SettingsPage';
import MessagingPage from './pages/MessagingPage';
import VideoCallPage from './pages/VideoCallPage';

function WorkflowRedirect({to}:{to:string}) {const location=useLocation();return <Navigate to={{pathname:to,search:location.search}} replace/>;}

function ProtectedLayout() {
  const profile = getStoredProfile();
  const token = getAuthToken();
  if (!token) return <Navigate to="/login" replace />;

  const handleLogout = () => {
    const token = getAuthToken();
    if (token) void fetch('/api/v1/auth/logout', { method: 'POST', headers: { Authorization: `Bearer ${token}` }, keepalive: true }).catch(() => undefined);
    clearAuthSession();
    window.location.href = '/login';
  };

  return (
    <Sidebar
      ownerName={profile?.name || profile?.hotel_name || 'Mon compte'}
      establishmentCount={profile?.establishment_count ?? 0}
      onLogout={handleLogout}
    >
      <Routes>
        <Route index element={<Navigate to="/assistant" replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="assistant" element={<QuickAssistantPage />} />
        <Route path="taxations" element={<TaxpayerWorkflowPage key="taxations" kind="taxations" />} />
        <Route path="dossier" element={<DossierPage />} />
 <Route path="traceability" element={<Navigate to="/history" replace />} />
 <Route path="suivi-fpt" element={<Navigate to="/dashboard" replace />} />
        <Route path="archives/declarations" element={<WorkflowRedirect to="/dossier" />} />
        <Route path="month-end" element={<WorkflowRedirect to="/declarations" />} />
        <Route path="declarations" element={<DeclarationRegisterPage key="active-declarations"/>} />
        <Route path="payments" element={<TaxpayerWorkflowPage key="payments" kind="payments"/>} />
        <Route path="debit-notes" element={<TaxpayerWorkflowPage key="notes" kind="notes"/>} />
        <Route path="quittances" element={<TaxpayerWorkflowPage key="receipts" kind="receipts"/>} />
        <Route path="payments/proofs" element={<TaxpayerWorkflowPage key="proofs" kind="proofs"/>}/>
        {Object.entries(workflowPaths).filter(([view])=>!['proofs','taxations'].includes(view)).map(([view,path])=><Route key={view} path={path.slice(1)} element={<WorkflowRedirect to={view==='debit-notes'?'/debit-notes':view==='receipts'?'/quittances':['to-pay','in-progress','partial','pending','paid'].includes(view)?'/payments':'/declarations'}/>}/>)}

            <Route path="archives/debit-notes" element={<WorkflowRedirect to="/debit-notes"/>} />
        <Route path="archives/payments" element={<WorkflowRedirect to="/payments"/>} />
        <Route path="archives/quittances" element={<WorkflowRedirect to="/quittances"/>} />
        <Route path="establishments" element={<EstablishmentsPage />} />
        <Route path="licenses" element={<LicensesPage />} />
        <Route path="renewals" element={<RenewalsPage />} />
        <Route path="messages" element={<MessagingPage />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="video" element={<VideoCallPage />} />
        <Route path="history" element={<TaxpayerWorkflowPage key="history" kind="history"/>} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Routes>
    </Sidebar>
  );
}

export default function App() {
  const [handoff, setHandoff] = useState(hasSessionHandoff() ? 'pending' : 'ready');
  const [handoffError, setHandoffError] = useState('');
  useEffect(() => {
    if (!hasSessionHandoff()) return;
    return beginSessionHandoff(() => setHandoff('ready'), message => { setHandoffError(message); setHandoff('error'); });
  }, []);
  if (handoff !== 'ready') return <div className="login-page"><div className="login-card">
    <h1>Connexion au Portail Assujetti FPT</h1>
    {handoff === 'pending' ? <p role="status">Vérification de votre session…</p> : <><p role="alert">{handoffError}</p><a className="btn primary" href="/login">Se connecter</a></>}
  </div></div>;
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/*" element={<ProtectedLayout />} />
      </Routes>
    </BrowserRouter>
  );
}
